import React from 'react';
import { Button, Icon, Label, Grid } from 'semantic-ui-react';
import NumberIncrementor from '../numberIncrementor/NumberIncrementor';
import { OUT_OF_STOCK_HIGHLIGHT_NAME } from '../gameCatalogCard/GameCatalogCard';
import './styles.css';

export default function QuantityActionWrapper({
    variant,
    showDetail,
    orderQty,
    incrementQuantity,
    decrementQuantity,
    game,
    impersonateRetailer,
    gameInCart,
    readOnly,
    gameInCartQty,
    localizeDetail,
    handleAddToCart,
    isEditOrder,
    showQuantity,
    showSuggestedQty,
}) {
    const quantityActionWrapper = `quantity-action-wrapper ${variant}-version`;

    return (
        <Grid className={quantityActionWrapper}>
            <Grid.Row className="add-item-action-wrapper">
                {showDetail && (
                    <NumberIncrementor
                        label={`${localizeDetail.quality}`}
                        value={orderQty}
                        onIncrease={incrementQuantity}
                        onDecrease={decrementQuantity}
                        disabled={
                            orderQty < 1 ||
                            game?.highlightName ===
                                OUT_OF_STOCK_HIGHLIGHT_NAME ||
                            impersonateRetailer
                        }
                    />
                )}
                {!!gameInCart && !readOnly && !impersonateRetailer && (
                    <Button
                        positive
                        className="update-cart-btn"
                        content={`${localizeDetail.update}`}
                        onClick={handleAddToCart}
                        disabled={
                            gameInCartQty === orderQty ||
                            game?.highlightName === OUT_OF_STOCK_HIGHLIGHT_NAME
                        }
                    />
                )}
                {showQuantity && <label>Quantity</label>}
                <Grid.Row className="display-quantity">
                    {game?.highlightName !== OUT_OF_STOCK_HIGHLIGHT_NAME && (
                        <>
                            {game.minimumOrderQuantity
                                ? `Min: ${game.minimumOrderQuantity}`
                                : `Min: 0`}{' '}
                            {game.maximumOrderQuantity &&
                            game.maximumOrderQuantity > 0
                                ? `, Max: ${game.maximumOrderQuantity}`
                                : `,Max: 0`}
                        </>
                    )}
                </Grid.Row>
                <Grid.Row className="d-flex">
                    {!!gameInCart
                        ? !readOnly &&
                          !impersonateRetailer && (
                              <Grid.Column>
                                  <Icon className="icon-Cart" />
                                  <Label circular color="yellow">
                                      {gameInCart}
                                  </Label>{' '}
                                  {isEditOrder ? 'in order' : 'in Cart'}
                              </Grid.Column>
                          )
                        : showDetail && (
                              <Grid.Column>
                                  <Button
                                      primary
                                      icon={<Icon className="icon-Cart" />}
                                      disabled={
                                          orderQty < 1 ||
                                          game?.highlightName ===
                                              OUT_OF_STOCK_HIGHLIGHT_NAME ||
                                          impersonateRetailer
                                      }
                                      content={
                                          isEditOrder
                                              ? `${localizeDetail.addToOrder}`
                                              : `${localizeDetail.cartButton}`
                                      }
                                      className="add-to-cart-btn m-0"
                                      onClick={handleAddToCart}
                                  />
                              </Grid.Column>
                          )}

                    {showSuggestedQty && (
                        <Grid.Column className="p-2">
                            <Label circular color="suggested-color">
                                {game?.suggestedQuantity ?? 0}
                            </Label>
                            <label>Suggested Qty</label>
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid.Row>
        </Grid>
    );
}
